import ButtonSymphony from "elements/ButtonSymphony";
import CardSymphony from "elements/CardSymphony";
import Icon from "elements/Icon";
import InputSymphony from "elements/InputSymphony";
import Loader from "elements/Loader";
import ModalSymphony from "elements/ModalSymphony";
import PageSymphony from "elements/PageSymphony";
import useApiKey from "Hooks/useApiKey";
import useUser from "Hooks/useUser";
import Colors from "modules/Colors";
import { makeKey } from "modules/Utils";
import { CSSProperties, useEffect, useState } from "react";
import { toast } from "react-toastify";

const ApiKeysPage = () => {
    const {
        currentUser
    } = useUser();

    const {
        apiKeys,
        isLoadingApiKey,
        createApiKey,
        getApiKeys,
        deleteApiKey,
    } = useApiKey();

    const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState<boolean>(false);
    const [selectedApiKey, setSelectedApiKey] = useState<string>('');

    useEffect(() => {
        getApiKeys({ userId: currentUser?.id });
    }, []);

    const copyToClipboard = (text: string) => {
        navigator.clipboard.writeText(text);
        toast.success('Copied to clipboard');
    }

    const renderApiKeyInfo = () => {
        return (
            <div className="apiKeyPageCardContent" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                {apiKeys.map((apiKey) => {
                    const { key } = apiKey;
                    return (
                        <div
                            key={makeKey(key, 'apiKeyPageCardInputContainer')}
                            className="apiKeyPageCardInputContainer"
                            style={sty.apiKeyPageCardInputContainer}
                        >
                            <InputSymphony
                                className="apiKeyPageCardInput"
                                value={key}
                                readOnly
                            />
                            <Icon
                                className="apiKeyPageCardCopyIcon"
                                icon="copy"
                                onClick={() => {
                                    copyToClipboard(key);
                                }}
                            />
                            <Icon
                                className="apiKeyPageCardDeleteIcon"
                                icon="trash"
                                onClick={() => {
                                    setShowConfirmDeleteModal(true);
                                    setSelectedApiKey(key);
                                }}
                                color={Colors.greyDark}
                            />
                        </div>
                    )
                })}
            </div>
        )
    }

    return (
        <>
            <PageSymphony
                className="apiKeyPageComponent"
                isContent
            >
                <CardSymphony
                    className="apiKeyPageCard"
                    title="SymphonyOS API"
                    subtitle="Create an API key to access SymphonyOS API"
                >
                    <ButtonSymphony
                        className="apiKeyPageCardButton"
                        onClick={() => {
                            createApiKey({ userId: currentUser?.id });
                        }}
                        isLoading={isLoadingApiKey}
                        disabled={isLoadingApiKey}
                        loadingText="Loading..."
                    >
                        Generate API Key
                    </ButtonSymphony>
                </CardSymphony>

                <CardSymphony
                    className="apiKeyPageCard"
                    title="API Keys"
                    subtitle="Manage your API keys"
                    size="small"
                >
                    {renderApiKeyInfo()}
                </CardSymphony>
            </PageSymphony>

            {/* MDOALS */}
            {showConfirmDeleteModal &&
                <ModalSymphony
                    className="apiKeyPageModal"
                    isOpen={showConfirmDeleteModal}
                    onClose={() => setShowConfirmDeleteModal(false)}
                    title="Delete API Key"
                    subtitle="Are you sure you want to delete this API key?"

                    onClickButtonLeft={() => {
                        setShowConfirmDeleteModal(false)
                        setSelectedApiKey('')
                    }}
                    buttonLeftText="Cancel"
                    buttonLeftVariant="text"
                    buttonLeftDisabled={isLoadingApiKey}
                    buttonLeftColor="grey"
                    buttonLeftClassName="cancelDeleteApiKeyButton"

                    onClickButtonRight={() => {
                        deleteApiKey({ key: selectedApiKey });
                        setShowConfirmDeleteModal(false);
                    }}
                    buttonRightText="Delete"
                    buttonRightDisabled={false}
                    buttonRightColor="red"
                    buttonRightIsLoading={isLoadingApiKey}
                    buttonRightLoadingText="Deleting API Key..."
                    buttonRightClassName="deleteApiKeyButton"
                />
            }
        </>
    )
}

const sty: Record<string, CSSProperties> = {
    apiKeyPageCardInputContainer: {
        display: 'flex',
        gap: 16,
        alignItems: 'center',
    },
}

export default ApiKeysPage;